<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
      </div>
      <div class="content-body">
        <div class="auth-wrapper auth-v2">
          <div class="auth-inner row m-0">
            <AuthLogo/>
            <!-- Left Text-->
            <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
              <div class="w-100 d-lg-flex align-items-center justify-content-center px-5"><img class="img-fluid"
                                                                                               :src="`${publicPath}app-assets/images/pages/login-v2.svg`"
                                                                                               alt="Login V2"/></div>
            </div>
            <!-- /Left Text-->
            <!-- Login-->
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <h3 class="card-title font-weight-bold mb-1"><img class="w-75" :src="`${publicPath}images/vaults-authlogo.png`"></h3>
                <h3 class="card-title font-weight-bold mb-1">Reset Your Pin! 👋</h3>
                <Form class="auth-login-form mt-2" @submit="sendCall"  :validation-schema="schema" :initial-values="{email: email}">
                  <div class="form-group">
                    <label class="form-label">Email</label>
                    <Field name="email" class="form-control" type="email" placeholder="Email" v-model="email" disabled/>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Passcode</label>
                    <Field name="passcode" class="form-control" type="password" placeholder="Passcode"/>
                    <ErrorMessage name="passcode"/>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Confirm Passcode</label>
                    <Field name="confirmPasscode" class="form-control" type="password" placeholder="Confirm Passcode" />
                    <ErrorMessage name="confirmPasscode"/>
                  </div>
                  <div class="form-group">
                    <label class="form-label">OTP</label>
                    <Field name="otp" class="form-control" type="text" placeholder="OTP"/>
                    <ErrorMessage name="otp"/>
                  </div>
                  <div class="mt-2">
                    <Button class="btn btn-primary btn-block" :loading="loader">Submit</Button>
                  </div>
                </form>
              </div>
            </div>
            <!-- /Login-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    if (typeof (this.$route.params.email) == 'undefined') {
      let email = localStorage.getItem('email');
      if (email != '' && email !== null) {
        this.email = email
      } else {
        this.$router.push({name: 'send-otp'});
      }
    } else {
      this.email = this.$route.params.email
    }
  },
  data() {
    return {
      loader: false,
      email : ''


    }
  },
  methods: {
    sendCall(values) {
      let data = values
      this.loader = true
      this.makeRequest('post', 'v1/reset-passcode', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.$router.push({name: 'passcode-login'});
          }
        }

      });
    },
  },
}
</script>


